import { Pipe, PipeTransform } from '@angular/core';

/**
 * Object having header attribute
 */
interface WithHeader {
  header: string;
}
/**
 * Object having tooltip attribute
 */
interface WithTooltip {
  tooltip: string;
}

/**
 * This Pipe receives an object with header and with tooltip values. It return the tooltip values if
 * tooltip value is not null and if it is different to header.
 */
@Pipe({
  name: 'columnTooltip',
  standalone: false,
})
export class ColumnTooltipPipe implements PipeTransform {
  /**
   * It Receives Any object with `header` and `tooltip` and returns if tooltip is not null and is different to header
   * @param param  - Union of {@link WithHeader} {@link WithTooltip}
   * @returns string
   */
  transform({ header, tooltip }: WithHeader & WithTooltip): string {
    const normalized = txt => txt?.trim().toLowerCase();
    const tooltipValue = normalized(tooltip);
    return !!tooltipValue && normalized(header) !== tooltipValue ? tooltip : null;
  }
}
